<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoCrud
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex>
                  <SelectModulo
                    :model="itemActivo.Id_Modulo"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="seleccionarModulo"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <SelectTipoComprobante
                    :id_Modulo="itemActivo.Id_Modulo"
                    :model="itemActivo.Id_TipoComprobante"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="
                      item =>
                        (itemActivo.Id_TipoComprobante =
                          item.Id_TipoComprobante)
                    "
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <SelectPuntoVenta
                    :model="itemActivo.Id_PuntoVenta"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="seleccionarPuntoVenta"
                  />
                </v-flex>
                <v-flex xs12 md2 offset-md2>
                  <v-text-field
                    label="Prefijo*"
                    v-model="itemActivo.PrefijoPuntoVenta"
                    :rules="[rules.requerido]"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <SelectTalonario
                    :id_PuntoVenta="itemActivo.Id_PuntoVenta"
                    :model="itemActivo.Id_Talonario"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="seleccionarTalonario"
                  />
                </v-flex>
                <v-flex xs4 md4>
                  <v-text-field
                    label="Nº Actual"
                    v-model="iNumeroActual"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <GrillaCrud
      :activo="grillaActivo"
      :columnas="grillaColumnas"
      :itemsDB="grillaItems"
      :loading="loading"
      @ejecutarAccion="grillaEjecutarAccion"
      @editarItem="grillaEditarItem"
      @borrarItem="grillaBorrarItem"
    />
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import EncabezadoCrud from "@/components/EncabezadoCrud";
import PieCrud from "@/components/PieCrud";
import GrillaCrud from "@/components/GrillaCrud";
import Mensaje from "@/components/Mensaje";
import SelectModulo from "@/components/Sistema/SelectModulo";
import SelectTipoComprobante from "@/components/Sistema/SelectTipoComprobante";
import SelectPuntoVenta from "@/components/Sistema/SelectPuntoVenta";
import SelectTalonario from "@/components/Sistema/SelectTalonario";
export default {
  name: "TipoComprobante_TalonarioCrud",
  components: {
    EncabezadoCrud,
    PieCrud,
    GrillaCrud,
    Mensaje,
    SelectModulo,
    SelectTipoComprobante,
    SelectPuntoVenta,
    SelectTalonario
  },
  data() {
    return {
      titulo: "Tipos de Comprobante",
      rutaApi: "TipoComprobante_Talonario/",
      itemVacio: {
        Id_Modulo: 0,
        Id_TipoComprobante: 0,
        Id_PuntoVenta: 0,
        PrefijoPuntoVenta: 0,
        Id_Talonario: 0,
        Letra: "",
        NumeroActual: 0
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      grillaColumnas: [
        { text: "Punto de Venta", value: "NombrePuntoVenta" },
        { text: "Módulo", value: "NombreModulo" },
        { text: "Tipo de Comprobante", value: "NombreTipoComprobante" },
        { text: "Letra", value: "Letra" },
        { text: "Prefijo", value: "PrefijoPuntoVenta" },
        { text: "Número", value: "NumeroActual" }
      ],
      grillaItems: [],
      grillaActivo: false,
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      controlSoloLectura: true,
      accion: ""
    };
  },
  computed: {
    iNumeroActual() {
      return this.itemActivo.Letra == undefined
        ? ""
        : this.itemActivo.Letra + " " + this.itemActivo.NumeroActual;
    }
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Nuevo":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = false;
          eventBus.$emit("setearFocoSelectModulo");
          break;
        case "Guardar":
          if (this.$refs.form.validate())
            this.mostrarMensaje(true, "ConfirmacionGuardar", null, null);
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "Abrir":
          this.grillaActivo = true;
          this.grillaItems = [];
          break;
        case "Editar":
          this.grillaActivo = false;
          this.controlSoloLectura = false;
          eventBus.$emit("setearFocoSelectPuntoVenta");
          break;
        case "Borrar":
          this.grillaActivo = false;
          this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          break;
        case "AceptarConfirmacionBorrar":
          this.borrarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarConfirmacionBorrar":
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = true;
          this.$refs.form.resetValidation();
          break;
      }
    },
    seleccionarModulo(item) {
      this.itemActivo.Id_Modulo = item.Id_Modulo;
    },
    seleccionarPuntoVenta(item) {
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.PrefijoPuntoVenta = item.Prefijo;
    },
    seleccionarTalonario(item) {
      this.itemActivo.Id_Talonario = item.Id_Talonario;
      this.itemActivo.Letra = item.Letra;
      this.itemActivo.NumeroActual = item.NumeroActual;
      this.itemActivo.NumeroHasta = item.NumeroHasta;
    },
    guardarItem(item) {
      this.loading = true;
      HttpHelper.post(this.rutaApi, item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    borrarItem(item) {
      this.loading = true;
      HttpHelper.delete(this.rutaApi + item.Id_TipoComprobante_Talonario)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEjecutarAccion(accion, textoBuscado) {
      switch (accion) {
        case "Listar":
          this.grillaListarItems(textoBuscado);
          break;
        case "Cerrar":
          this.grillaActivo = false;
          break;
      }
    },
    grillaListarItems(textoBuscado) {
      this.loading = true;
      this.grillaItems = [];
      HttpHelper.get(this.rutaApi, {
        palabra: textoBuscado
      })
        .then(response => {
          this.grillaItems = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEditarItem(item) {
      this.loading = true;
      HttpHelper.get(this.rutaApi, {
        id: item.Id_TipoComprobante_Talonario
      })
        .then(response => {
          this.itemActivo = Object.assign({}, response.data);
          this.ejecutarAccion("Editar");
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaBorrarItem(item) {
      this.itemActivo = item;
      this.ejecutarAccion("Borrar");
    },
    mostrarError(error) {
      let detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
